import { render } from "./DiagnosticsPanel.vue?vue&type=template&id=277bc8b0&scoped=true"
import script from "./DiagnosticsPanel.vue?vue&type=script&lang=js"
export * from "./DiagnosticsPanel.vue?vue&type=script&lang=js"

import "./DiagnosticsPanel.vue?vue&type=style&index=0&id=277bc8b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277bc8b0"]])

export default __exports__